module.exports = __webpack_public_path__ + "img/icon_launch.20b36fbd.svg";